import React from 'react';
import CategoryDTO from '../../../lib/CategoryDTO';
import DocumentDTO from '../../../lib/DocumentDTO';
import DocumentItem from '../../atoms/documentItem';

interface Props {
    className?: string;
    documents: DocumentDTO[];
    selectedCategory: CategoryDTO | null;
}

const DocumentList = ({
    className = '',
    documents,
    selectedCategory,
}: Props) => {
    const baseClassName = 'w-sharedDocumentDownload-documentList';

    return (
        <div className={`${baseClassName} ${className}`}>
            {documents
                .filter(doc => selectedCategory === null || doc.categoryIds.includes(selectedCategory.id))
                .map(doc => <DocumentItem key={doc.id} document={doc} />)}
        </div>
    );
};

export default DocumentList;
